module.exports = __webpack_public_path__ + "img/back_100.a031670b.png";